// extracted by mini-css-extract-plugin
export default {"content":"quote_over_image_content__cfPXr","transparentBg":"quote_over_image_transparentBg__8GSNB","content_text":"quote_over_image_content_text__dk8Ne"};